import React  from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';

const StrategicObjectives = () => {
    const navigate = useNavigate();
    const goBack = () => {
      navigate(-1);
    }
    return(
        <>
        <div className="about-container">
        <div className="content-left">
        <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
             <h1>Strategic Objectives</h1>
           <p>To enhance wealth creation and economic growth by strategically investing in Nepal's stock market, subsidiary companies, and major corporations, while fostering sustainable business practices and delivering long-term value to shareholders.



<ul>
    <li><b>Maximize Shareholder Value:</b> Generate sustainable financial returns through strategic investments in Nepal's stock market, subsidiary companies, and leading corporations.</li>
    <li><b>Promote Economic Growth:</b> Support the development of Nepal's economy by investing in high-potential sectors and fostering innovation in subsidiaries.</li>
    <li><b>Diversify Investment Portfolio:</b> Ensure risk mitigation and stable growth by maintaining a balanced investment approach across various industries.</li>
    <li><b>Strengthen Subsidiary Performance:</b> Enhance the operational and financial capabilities of subsidiary companies to achieve long-term success.</li>
    <li><b>Foster Strategic Partnerships:</b> Collaborate with Nepal's major companies to drive mutual growth and create value-driven synergies.</li>
</ul>





</p>
        </div>
        </div>
        </>
    )
}


export default StrategicObjectives;